import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import Hai from './Hai';
import { sortHais } from '../haiUtils';

const styles = {
  area: {
    padding: '10px',
    border: '2px solid #ccc',
    borderRadius: '5px',
    // スコア表示の分、他のエリアより高さを確保する
    minHeight: '110px',
    display: 'flex',
    alignItems: 'center',
    // PCではスクロールを許可し、スマホでは牌を縮小して全体表示
    overflowX: { xs: 'hidden', sm: 'auto' },
    '&::-webkit-scrollbar': {
      height: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '4px',
    },
  },
};

const PredictionResult = ({ prediction, tehai }) => {
  // APIレスポンスが期待通りでない場合、何も表示しない
  if (!prediction || !prediction.probabilities || !prediction.predicted) {
    return null;
  }

  // 1. probabilitiesオブジェクトを {hai_id, score} の配列に変換
  const candidates = Object.entries(prediction.probabilities).map(([hai_id, score]) => ({
    hai_id: parseInt(hai_id, 10),
    score: score,
  }));

  // 2. 手牌を基準にユニークなソート済みリストを作成
  const uniqueSortedTehai = [...new Set(sortHais(tehai))];

  // 3. 変換した打牌候補を、手牌の並び順でソート
  const sortedCandidates = candidates.sort(
    (a, b) => uniqueSortedTehai.indexOf(a.hai_id) - uniqueSortedTehai.indexOf(b.hai_id)
  );

  // 4. 最も推奨される打牌を特定
  const bestChoiceId = prediction.predicted;

  return (
    <>
      <Typography variant="subtitle2" gutterBottom>推論結果</Typography>
      <Box sx={styles.area}>
        {/* FlexboxからCSS Gridに変更し、レイアウトの安定性を向上させます */}
        <Box sx={{
          display: 'grid',
          // スマホでは7列x2行のグリッドを、PCではコンテンツに合わせたレスポンシブなグリッドを定義します
          gridTemplateColumns: { xs: 'repeat(7, 1fr)', sm: 'repeat(auto-fill, minmax(40px, 1fr))' },
          gap: { xs: '4px', sm: '8px' }, // アイテム間の隙間
          width: '100%',
        }}>
          {sortedCandidates.map((candidate) => (
            <Box
              key={candidate.hai_id}
              sx={{
                position: 'relative',
                minWidth: 0, // グリッドアイテムがコンテンツによって不必要に広がるのを防ぐ
              }}
            >
              <Paper
                elevation={0} // 影をなくす
                sx={{
                  width: '100%',
                  boxSizing: 'border-box',
                  padding: '0px 2px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  backgroundColor: 'transparent', // Paperの背景を透明に
                  borderRadius: '4px',
                }}
              >
                <Box sx={(theme) => ({
                  width: '100%',
                  borderRadius: '2px',
                  boxSizing: 'border-box',
                  // 枠線が画像と重ならないように、borderの代わりにbox-shadowで枠線を表現します
                  // これにより、要素のサイズに影響を与えずに外側に枠線が描画されます
                  boxShadow: candidate.hai_id === bestChoiceId ? `0 0 0 2px ${theme.palette.primary.main}` : 'none',
                  // 牌の画像と枠線の間に隙間を作るためのパディング
                  padding: '2px',
                })}>
                  <Hai haiId={candidate.hai_id} />
                </Box>
                <Typography variant="caption" sx={{
                  mt: 1,
                  color: candidate.hai_id === bestChoiceId ? 'primary.main' : 'text.secondary',
                  fontWeight: candidate.hai_id === bestChoiceId ? 'bold' : 'normal',
                  // テキストがコンテナの幅を超えないように、折り返しを禁止し、はみ出した部分を省略記号(...)で表示する
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  {`${(candidate.score * 100).toFixed(1)}%`}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default PredictionResult;